export const createEmptyArray = (length: number): number[] => {
  const numbers: number[] =[]

  for(let i = 0; i < length; i += 1) {
    numbers.push(i)
  }

  return numbers
}
